import React from 'react';

export class RoundButton extends React.Component {
    constructor(props) {
        super(props);

        this.clicked  = this.clicked.bind(this);

    }

    clicked()
    {
       this.props.callback(this.props.event_name);
    }


    render() {
        return (<a href={"javascript:void(0)"} onClick={this.clicked} className={"button"}>
                {this.props.label}
            </a>

        );
    }

}
